import React, { PropsWithChildren } from 'react'
import classes from './Popper.module.scss'
import { Popper as MuiPopper, PopperProps as MuiPopperProps } from '@mui/base/Popper'

export type PopperProps = PropsWithChildren<MuiPopperProps>

export const Popper = ({ children, ...props }: PopperProps) => {
  return (
    <MuiPopper className={classes.root} {...props}>
      <div className={classes.content}>{children}</div>
    </MuiPopper>
  )
}
